import { useApiQuery } from '@/modules/common';

import { ModelsAttributes } from '../types';

export function useModelAttributes() {
  const { data, isFetching } = useApiQuery<ModelsAttributes>(
    '/models/attributes',
    {
      queryKey: ['modelsAttributes'],
      initialData: {
        colors: [],
        types: [],
        genders: [],
        sizes: [],
        fileNames: [],
      },
    }
  );

  return {
    data,
    isFetching,
  } as const;
}
